import { render, staticRenderFns } from "./propertyPayCostIndex.vue?vue&type=template&id=f2986252&scoped=true&"
import script from "./propertyPayCostIndex.vue?vue&type=script&lang=js&"
export * from "./propertyPayCostIndex.vue?vue&type=script&lang=js&"
import style0 from "./propertyPayCostIndex.vue?vue&type=style&index=0&id=f2986252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2986252",
  null
  
)

export default component.exports